/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2020
 * @format
 * @flow
 */

import React, { useEffect, useRef, useState } from 'react';
import { Stage } from 'react-konva';
import PropTypes from 'prop-types';
import styles from './Stage.module.css';

const KonvaStage = (props) => {
  const { onTap, onMouseDown, backgroundColor, children, height, stageContainerBackgroundColor } = props;
  const [stageWidth, setStageWidth] = useState(1000);
  const [stageHeight, setStageHeight] = useState(1000);
  const containerRef = useRef();
  const screenRatio = { width: 10, height: 7 };

  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const onResize = () => {
    const width = containerRef.current.offsetWidth;
    const height = containerRef.current.offsetHeight;
    // const minSize = Math.min(width, height);
    setStageWidth(width);
    setStageHeight(height);
  };

  // Fixed stage size
  const SCENE_BASE_WIDTH = 1200;
  const SCENE_BASE_HEIGHT = 1100;

  // Max upscale
  const SCENE_MAX_WIDTH = Math.max(window.innerWidth, 1280);
  const SCENE_MAX_HEIGHT = Math.max(window.innerHeight, 1100);

  // scaleX & scaleY
  const scaleX = Math.min(stageWidth, SCENE_MAX_WIDTH) / SCENE_BASE_WIDTH;
  const scaleY = Math.min(stageHeight, SCENE_MAX_HEIGHT) / SCENE_BASE_HEIGHT;

  // Min ratio & scale
  const minRatio = Math.min(scaleX, scaleY);
  const scale = { x: minRatio, y: minRatio };

  return (
    <div
      ref={containerRef}
      style={{
        height: height,
        backgroundColor: backgroundColor || '#2a2a2a',
      }}
      className={styles.container}
    >
      <Stage
        width={screenRatio.width * 100}
        height={screenRatio.height * 100}
        onTap={onTap}
        onMouseDown={onMouseDown}
        // scale={scale}
        scale={{ x: 1, y: 1 }}
        style={{
          backgroundColor: stageContainerBackgroundColor || '#2a2a2a',
          width: screenRatio.width * 100,
          height: screenRatio.height * 100,
        }}
      >
        {children}
      </Stage>
    </div>
  );
};

export default KonvaStage;

KonvaStage.propTypes = {
  onTap: PropTypes.func,
  onMouseDown: PropTypes.func,
  children: PropTypes.any,
  backgroundColor: PropTypes.string,
  stageContainerBackgroundColor: PropTypes.string,
};

KonvaStage.defaulProps = {
  onTap: () => { },
  onMouseDown: () => { },
  backgroundColor: '#2a2a2a',
  stageContainerBackgroundColor: '#2a2a2a'
};
